import { print } from 'graphql'
import { CustomerAccessToken } from 'shopify-types'

import { storefrontClient } from '..'
import { LoginCustomerDocument, type LoginCustomerMutation } from '../__generated/storefront'

type LoginCustomerInput = Readonly<{
  email: string
  password: string
}>

export const loginCustomer =
  () =>
  async (input: LoginCustomerInput): Promise<CustomerAccessToken> => {
    const response = await storefrontClient.request<LoginCustomerMutation>(
      print(LoginCustomerDocument),
      {
        variables: {
          input,
        },
      },
    )

    const payload = response.data?.customerAccessTokenCreate

    if (!payload?.customerAccessToken?.accessToken) {
      throw new Error('Failed to login customer')
    }

    return payload.customerAccessToken as CustomerAccessToken
  }
